import { Settings } from "lucide-react";
import { TimeoffPolicy } from "../../../../types";

interface PolicyCardProps {
    title: string;
    activeMenu: string | null;
    setActiveMenu: (menu: string | null) => void;
    policy: TimeoffPolicy;
    onEditClicked: (policy: TimeoffPolicy) => void;
}

const PolicyCard: React.FC<PolicyCardProps> = ({ title, activeMenu, setActiveMenu, onEditClicked, policy }) => {
    const isActive = activeMenu === title;

    const handleEditClicked = () => { 
        setActiveMenu(null);
        onEditClicked(policy);
    }

    return (
        <div className="p-4 bg-white rounded-lg flex justify-between items-center border border-gray-300 relative">
            <h3 className="text-lg font-bold text-gray-700">{title}</h3>
            <button onClick={() => setActiveMenu(isActive ? null : title)} className="text-gray-500">
                <Settings size={20} />
            </button>
            {isActive && (
                <div className="absolute right-0 top-10 bg-white border border-gray-300 shadow-lg rounded-lg p-2 w-40 z-10">
                    <p className="cursor-pointer p-2 hover:bg-gray-100" onClick={handleEditClicked}>
                        Edit
                    </p>
                </div>
            )}
        </div>
    );
};

export default PolicyCard;
